export const planApprovalPoints = {
  path: "/planApprovalPoints",
  name: "planApprovalPoints",
  component: () => import("@/CommonDP/pages/mainMg/application/standard/planApprovalPoints/index.vue"),
  meta: {
    routeName: "审图要点",
    prouteName: "审图要点",
    ppname: "设置",
    icon1: require("@/views/assets/settings/sysSetting1.png"),
    icon2: require("@/views/assets/settings/sysSetting2.png"),
  },
};

// 设置
export function settings(routerMap) {
  routerMap.journal.component = () => import("@/views/settings/log/index.vue");
  routerMap.projectApproval.meta.routeName = "流程"
  routerMap.projectApproval.meta.prouteName = "流程"
}
